import { useEffect } from 'react';

/**
 * Custom hook to dynamically set page titles
 * @param {string} title - The page title to set
 * @param {boolean} includeBrand - Whether to include brand name in title
 */
const usePageTitle = (title, includeBrand = true) => {
  useEffect(() => {
    const brandName = 'DeviceLink Global';
    
    if (title) {
      document.title = includeBrand ? `${title} | ${brandName}` : title;
    } else {
      // Default empty title for landing page
      document.title = '';
    }

    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = '';
    };
  }, [title, includeBrand]);
};

export default usePageTitle;
